import type { ReactNode } from "react";

import { Box } from "@jti/core-components/components/Box";
import { useTranslations } from "@jti/ui";

type OrderDotContentType = {
  condition: boolean;
  children: ReactNode;
  title: string;
  className: string;
};

export const OrderDotContent = ({ condition, children, title, className }: OrderDotContentType) => {
  const { __ } = useTranslations();

  return (
    <div className={className}>
      <Box title={__(title)} variant="level-2">
        {!condition ? <>...</> : <>{children}</>}
      </Box>
    </div>
  );
};
